import React, { useState, useEffect } from 'react'
import Nang from '../images/nmz.png'
import { FaFacebook, FaGithub, FaLinkedinIn, FaPhone, FaEnvelope, FaDownload, FaChevronDown, FaGlobe } from "react-icons/fa";
import { BiLogoGmail } from "react-icons/bi";
import { HiDownload } from "react-icons/hi";
import { Link } from 'react-router-dom';
import CV from '../images/cv/Nang_Myintzu.pdf';
import Bubbles from './Bubbles';

const contactInfo = {
  name: 'Nang Myintzu',
  title: 'Chief Technology Officer',
  company: 'WeTech MM Solutions',
  phone: '+959259599508 ',
  email: 'nangmyintzu89@gmail.com',
  facebook: 'https://www.facebook.com/profile.php?id=100010036154961&mibextid=ZbWKwL',
  github: 'https://github.com/NangMyintzu-Yuki',
  linkedin: 'https://www.linkedin.com/in/nangmyintzu/',
  website:"https://www.nangmyintzu.site"
};

const generateVCard = () => {
  const vcard = `BEGIN:VCARD
VERSION:3.0
N:${contactInfo.name.split(' ').slice(-1)[0]};${contactInfo.name.split(' ').slice(0, -1).join(' ')};;;
FN:${contactInfo.name}
ORG:${contactInfo.company}
TITLE:${contactInfo.title}
TEL;TYPE=CELL:${contactInfo.phone}
EMAIL:${contactInfo.email}
URL:${contactInfo.website}
END:VCARD`;

  const blob = new Blob([vcard], { type: 'text/vcard;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'NangMyintzu.vcf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const MobileNameCard = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  // Set --vh CSS variable for mobile browser address bar handling
  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
    setVH();
    window.addEventListener('resize', setVH);
    window.addEventListener('orientationchange', setVH);
    return () => {
      window.removeEventListener('resize', setVH);
      window.removeEventListener('orientationchange', setVH);
    };
  }, []);

  const sendMail = () => {
    window.location.href = `mailto:${contactInfo.email}`;
  };

  const callPhone = () => {
    window.location.href = `tel:${contactInfo.phone}`;
  };

  const downloadCV = () => {
    const anchor = document.createElement('a');
    anchor.href = CV;
    anchor.download = 'NangMyintzu.pdf';
    anchor.click();
  };

  return (
    <section className="md:hidden relative bg-primary-bg overflow-hidden noise-overlay flex flex-col" style={{ minHeight: '100dvh' }}>
      {/* Background effects */}
      <div className="absolute inset-0 gradient-mesh pointer-events-none" />
      <div className="absolute inset-0 grid-pattern pointer-events-none opacity-30" />
      <Bubbles count={8} />

      {/* Decorative orbs */}
      <div className="absolute top-16 right-4 w-48 h-48 bg-accent/5 rounded-full blur-3xl animate-float-slow pointer-events-none" />
      <div className="absolute bottom-32 left-4 w-40 h-40 bg-accent/3 rounded-full blur-3xl animate-float-fast pointer-events-none" />

      {/* Name Card */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-6 py-20">
        {/* Profile Image */}
        <div
          className="relative mb-5"
          style={{
            animation: isVisible ? 'scaleIn 0.6s ease-out forwards' : 'none',
            opacity: isVisible ? undefined : 0,
          }}
        >
          <div className="absolute -inset-1.5 rounded-full border border-accent/25 animate-pulse-glow" />
          <div className="relative w-[150px] h-[150px] rounded-full overflow-hidden border-2 border-accent/25 shadow-lg shadow-accent/10">
            <img
              src={Nang}
              alt="Nang Myintzu — Chief Technology Officer at WeTech"
              className="w-full h-full object-cover object-top scale-110 pt-2"
            />
          </div>
          {/* Status dot */}
          <div className="absolute bottom-1 right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-primary-bg animate-pulse" />
        </div>

        {/* Name & Title */}
        <div
          className="text-center mb-5"
          style={{
            animation: isVisible ? 'fadeInUp 0.6s 0.15s ease-out forwards' : 'none',
            opacity: isVisible ? undefined : 0,
          }}
        >
          <h1 className="text-accent font-bold text-2xl tracking-wide uppercase mb-1">
            {contactInfo.name}
          </h1>
          <p className="text-white font-semibold text-base mb-0.5">
            {contactInfo.title}
          </p>
          <p className="text-gray-dark text-sm font-light tracking-wider">
            {contactInfo.company}
          </p>
        </div>

        {/* Divider */}
        <div
          className="w-16 h-[1px] bg-gradient-to-r from-transparent via-accent/50 to-transparent mb-5"
          style={{
            animation: isVisible ? 'fadeIn 0.6s 0.3s ease-out forwards' : 'none',
            opacity: isVisible ? undefined : 0,
          }}
        />

        {/* About Intro */}
        <div
          className="text-center mb-6 max-w-[320px]"
          style={{
            animation: isVisible ? 'fadeInUp 0.6s 0.35s ease-out forwards' : 'none',
            opacity: isVisible ? undefined : 0,
          }}
        >
          <p className="text-gray text-xs leading-relaxed">
            Technology leader with deep expertise in full-stack development,
            scalable architecture, and product strategy. Building ventures
            that drive digital transformation.
          </p>
        </div>

        {/* Contact Info */}
        <div
          className="w-full max-w-[320px] space-y-2.5 mb-6"
          style={{
            animation: isVisible ? 'fadeInUp 0.6s 0.45s ease-out forwards' : 'none',
            opacity: isVisible ? undefined : 0,
          }}
        >
          {/* Phone */}
          <button
            onClick={callPhone}
            className="w-full flex items-center gap-3 p-3 glass-card rounded-xl hover-glow active:scale-[0.98] transition-all duration-200"
          >
            <div className="w-9 h-9 rounded-lg bg-accent/10 flex items-center justify-center flex-shrink-0">
              <FaPhone className="text-accent text-sm" />
            </div>
            <div className="text-left flex-1 min-w-0">
              <p className="text-[10px] text-gray-dark uppercase tracking-wider">Phone</p>
              <p className="text-white text-sm truncate">{contactInfo.phone}</p>
            </div>
          </button>

          {/* Email */}
          <button
            onClick={sendMail}
            className="w-full flex items-center gap-3 p-3 glass-card rounded-xl hover-glow active:scale-[0.98] transition-all duration-200"
          >
            <div className="w-9 h-9 rounded-lg bg-accent/10 flex items-center justify-center flex-shrink-0">
              <FaEnvelope className="text-accent text-sm" />
            </div>
            <div className="text-left flex-1 min-w-0">
              <p className="text-[10px] text-gray-dark uppercase tracking-wider">Email</p>
              <p className="text-white text-sm truncate">{contactInfo.email}</p>
            </div>
          </button>

          {/* Website */}
          <a
            href={contactInfo.website}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center gap-3 p-3 glass-card rounded-xl hover-glow active:scale-[0.98] transition-all duration-200"
          >
            <div className="w-9 h-9 rounded-lg bg-accent/10 flex items-center justify-center flex-shrink-0">
              <FaGlobe className="text-accent text-sm" />
            </div>
            <div className="text-left flex-1 min-w-0">
              <p className="text-[10px] text-gray-dark uppercase tracking-wider">Website</p>
              <p className="text-white text-sm truncate">nangmyintzu.site</p>
            </div>
          </a>
        </div>

        {/* Social Icons */}
        <div
          className="flex items-center gap-3 mb-6"
          style={{
            animation: isVisible ? 'fadeInUp 0.6s 0.55s ease-out forwards' : 'none',
            opacity: isVisible ? undefined : 0,
          }}
        >
          {[
            { icon: <FaFacebook />, url: contactInfo.facebook, label: "Facebook" },
            { icon: <FaGithub />, url: contactInfo.github, label: "GitHub" },
            { icon: <FaLinkedinIn />, url: contactInfo.linkedin, label: "LinkedIn" },
            { icon: <BiLogoGmail />, url: `mailto:${contactInfo.email}`, label: "Gmail" },
          ].map((social, i) => (
            <a
              key={i}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.label}
              className="w-11 h-11 rounded-full border border-primary-border flex items-center justify-center text-accent hover:border-accent/60 hover:text-white hover:bg-accent/10 hover:shadow-accent text-lg transition-all duration-300 hover:scale-110 active:scale-95"
            >
              {social.icon}
            </a>
          ))}
        </div>

        {/* Action Buttons */}
        <div
          className="w-full max-w-[320px] space-y-2.5"
          style={{
            animation: isVisible ? 'fadeInUp 0.6s 0.65s ease-out forwards' : 'none',
            opacity: isVisible ? undefined : 0,
          }}
        >
          {/* Save Contact Button */}
          <button
            onClick={generateVCard}
            className="w-full flex items-center justify-center gap-2 bg-accent text-primary-bg rounded-xl font-semibold py-3.5 border border-accent hover:bg-accent-dark transition-all duration-300 text-sm shadow-accent hover:shadow-accent-lg active:scale-[0.98]"
          >
            <HiDownload size="18px" />
            Save Contact
          </button>

          {/* Download CV */}
          {/* <button
            onClick={downloadCV}
            className="w-full flex items-center justify-center gap-2 bg-transparent text-accent rounded-xl font-semibold py-3 border border-accent/40 hover:bg-accent/10 hover:border-accent transition-all duration-300 text-sm active:scale-[0.98]"
          >
            <FaDownload size="14px" />
            Download CV
          </button> */}

          {/* More About Me */}
          <Link
            to="/about"
            className="w-full flex items-center justify-center gap-2 bg-transparent text-gray hover:text-white rounded-xl font-medium py-2.5 text-xs transition-all duration-300"
          >
            More About Me
            <FaChevronDown size="12px" className="animate-bounce" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default MobileNameCard;
